import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify';

const baseUrlUser = process.env.REACT_APP_USER_MANAGEMENT;
const baseUrlUserEvent = process.env.REACT_APP_EVENT_MANAGEMENT;


export const getInvestor = createAsyncThunk('getInvestor', async (investor_type, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlUser}/organizations/${investor_type}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getAllCountries = createAsyncThunk('getAllCountries', async (thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlUser}/fetchCountries`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getAllOrganisationProfiles = createAsyncThunk(
    'getAllOrganisationProfiles',
    async (queryParams, { thunkAPI }) => {
        try {
            const response = await axios.get(`${baseUrlUser}/getAllOrganisationProfiles`, { params: queryParams });
            const { payload } = response.data;
            return payload;
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getOrganizationDetails = createAsyncThunk('getOrganizationDetails', async (req, thunkAPI) => {
    try {
        const response = await axios.post(`${baseUrlUser}/organization`, req);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getBuyerStats = createAsyncThunk('getBuyerStats', async (orgUlid, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlUser}/buyerstats?orgId=${orgUlid}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const getSupplierStats = createAsyncThunk('getSupplierStats', async (orgUlid, thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlUser}/supplierstats?orgId=${orgUlid}`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const pricingConfigurator = createAsyncThunk('pricingConfigurator', async (req, thunkAPI) => {
    try {
        const response = await axios.put(`${baseUrlUser}/pricingconfigurator`, req);

        if (response) {
            toast.success(response.serviceMessage || response?.data?.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });
        }
        const payload = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});
export const getPricingConfigurator = createAsyncThunk('getPricingConfigurator', async (thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlUser}/pricingconfigurator`);
        const { payload } = response.data;
        return payload;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getPastPricingConfigurator = createAsyncThunk('getPastPricingConfigurator', async (req,thunkAPI) => {
    try {
        const response = await axios.get(`${baseUrlUserEvent}/events`,{
          params: {
              organizationULID: req,
            eventType: 'pricing_configurator',
          }});
        const { payload } = response.data;
        return payload;
        
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const getSupplierPortsProducts = createAsyncThunk('getSupplierPortsProducts', async (queryParams, thunkAPI) => {
    const { organization_ulid } = queryParams;
    if (organization_ulid === "''" || organization_ulid === '') {
        return thunkAPI.rejectWithValue('Invalid organization_ulid');
    }

    try {
        const response = await axios.get(`${baseUrlUser}/getsupplierportsproducts`, { params: queryParams });

        const { payload, next_cursor, has_next } = response.data;
        return { payload, next_cursor, has_next, supOrgUlid: organization_ulid };
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const checkForWhitelistedSupplier = createAsyncThunk('checkForWhitelistedSupplier', async (req, thunkAPI) => {
    const { organization_ulid, is_whitelisted_supplier } = req;
    try {
        const response = await axios.put(
            `${baseUrlUser}/whitelistsupplier/${organization_ulid}/${is_whitelisted_supplier}`
        );

        if (response) {
            toast.success(response.serviceMessage || response?.data?.serviceMessage, {
                icon: <i className='bi bi-check-circle-fill' style={{ color: '#409895' }}></i>,
            });
        }
        const payload = response.data;
        return payload;
    } catch (error) {
        const errorMessage = error.response?.data?.serviceMessage || error.message;
        toast.error(errorMessage);
        return thunkAPI.rejectWithValue(errorMessage);
    }
});

export const getCalculateRiskFactorScoreAndWeight = createAsyncThunk(
    'getCalculateRiskFactorScoreAndWeight',
    async (queryParams, thunkAPI) => {
        try {
            const response = await axios.get(`${baseUrlUser}/calculateRiskFactorScoreAndWeight`, {
                params: queryParams,
            });
            const { payload } = response.data;
            return payload;
        } catch (error) {
            const errorMessage = error.response?.data?.serviceMessage || error.message;
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const postCalculateRiskFactorScoreAndWeight = createAsyncThunk(
    'postCalculateRiskFactorScoreAndWeight',
    async (req, thunkAPI) => {
        try {
            const response = await axios.post(`${baseUrlUser}/calculateRiskFactorScoreAndWeight`, req);
            const { payload } = response.data;
            return payload;
        } catch (error) {
            const errorMessage = error.response?.data?.serviceMessage || error.message;
            toast.error(errorMessage);
            return thunkAPI.rejectWithValue(error);
        }
    }
);
